import { INVALIDATE_TYPE } from '../actionTypes.js';
export default function createInvalidate(endpoint, _ref) {
  let {
    args
  } = _ref;
  return {
    type: INVALIDATE_TYPE,
    meta: {
      key: endpoint.key(...args)
    }
  };
}